import { Suspense, lazy } from "react";
import { Navigate, useRoutes, useLocation } from "react-router-dom";
// layouts
import DashboardLayout from "../layouts/dashboard";

// guards
import GuestGuard from "../guards/GuestGuard";
import AuthGuard from "../guards/AuthGuard";
// import RoleBasedGuard from '../guards/RoleBasedGuard';
// config
import { PATH_AFTER_LOGIN } from "../config";
// components
import LoadingScreen from "../components/LoadingScreen";
import CreateOrder from "src/pages/create-order";
import GSTReport from "src/pages/reports/GSTReport";

// ----------------------------------------------------------------------

export const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();

  return (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    {
      path: "auth",
      children: [
        {
          path: "login",
          element: (
            <GuestGuard>
              <Login />
            </GuestGuard>
          ),
        },
      ],
    },
    // Dashboard Routes
    {
      path: "dashboard",
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: "app", element: <SchoolOrder /> },
        { path: "create-order", element: <CreateOrder /> },
        {
          path: "reports",
          children: [
            {
              element: <Navigate to="/dashboard/reports/new-report" replace />,
              index: true,
            },
            { path: "new-report", element: <NewOrder /> },
            {
              path: "new-and-pending-report",
              element: <NewAndPendingReport />,
            },
            { path: "student-wise-pending-report", element: <StudentWisePendingOrders /> },
            { path: "school-wise-pending-report", element: <SchoolWisePendingOrders /> },
            { path: "date-wise-report", element: <OrderedProductReport /> },
            { path: "order-wise-gst-report", element: <OrderWiseGSTReport /> },
            { path: "sale-with-gst", element: <GSTReport type={"withGst"} /> },
            { path: "sale-without-gst-report", element: <GSTReport /> },
            { path: "sales-report", element: <SalesReport /> },
            {
              path: "shipping-wise-report",
              element: <GSTReport type={"shipping"} />,
            },
          ],
        },
      ],
    },
    // Main Routes

    {
      path: "/",
      element: (
        <GuestGuard>
          <Login />
        </GuestGuard>
      ),
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}

// AUTHENTICATION
const Login = Loadable(lazy(() => import("../pages/auth/Login")));

// DASHBOARD

// GENERAL
const SchoolOrder = Loadable(lazy(() => import("../pages/school")));
const NewAndPendingReport = Loadable(
  lazy(() => import("src/pages/reports/NewAndPendingReport"))
);
const OrderedProductReport = Loadable(
  lazy(() => import("src/pages/reports/OrderedProductReport"))
);
const OrderWiseGSTReport = Loadable(
  lazy(() => import("src/pages/reports/OrderWiseGSTReport"))
);
const NewOrder = Loadable(lazy(() => import("src/pages/reports/NewOrder")));
const SalesReport = Loadable(lazy(() => import("src/pages/reports/SalesReport")));
const StudentWisePendingOrders = Loadable(
  lazy(() => import("src/pages/reports/StudentWisePendingOrders"))
);
const SchoolWisePendingOrders = Loadable(
  lazy(() => import("src/pages/reports/SchoolwisePendingOrders"))
);
